<ng-template #glnDialog>
  <h1 mat-dialog-title>Donner de la visibilité à vos GLN</h1>
       <div mat-dialog-content style="font-weight:400" >

    <p class="gs1-little">
      Certains de vos codes GLN ne sont pas associés à un « type ». <br />
      Merci d'en associer un ou plusieurs aux GLN concernés. <br />
      Sans « type », vos GLN ne peuvent être visibles dans l'annuaire international GS1 :
      <a target="_blank" href="https://www.gs1.org/services/verified-by-gs1">Verified by GS1</a>.
    </p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button gs1Button (click)="closeDialog()">Ok, j'ai compris !</button>
  </div>
</ng-template>
